var map = {
	"./imge1.png": "cd2b",
	"./imge10.png": "958f",
	"./imge11.png": "06f9",
	"./imge12.png": "7aea",
	"./imge13.png": "5729",
	"./imge14.png": "e742",
	"./imge15.png": "8c97",
	"./imge2.png": "5a90",
	"./imge3.png": "f105",
	"./imge4.png": "90e6",
	"./imge5.png": "a838",
	"./imge6.png": "d9da",
	"./imge7.png": "6f1d",
	"./imge8.png": "5dcc",
	"./imge9.png": "c87c",
	"./syllabus_imge1.png": "1026",
	"./syllabus_imge2.png": "8e2f",
	"./syllabus_imge3.png": "b5ea"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7574";